import { ConfirmationModalService } from './../../+shared/components/confirmation-modal/confirmation-modal.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CopyApplicationDataRequest, GetApplicationDataResponse } from './copy-application-data.domain';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { CopyApplicationDataService } from './copy-application-data.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ErrorService } from 'src/app/services/error/error.service';
import { SkApplicationType } from 'src/app/domains/common.domain';
import { NetzTranslateService } from 'src/app/services/netz-translate.service';
import { ToastNotificationService } from 'src/app/+shared/services/toast-notification.service';
import { BehaviorSubject, combineLatest, forkJoin, Subject } from 'rxjs';

@Component({
  selector: 'app-copy-application-data',
  templateUrl: './copy-application-data.component.html',
})
export class CopyApplicationDataComponent extends DestroyableComponent implements OnInit {
  @Input() installationFlow: string;
  @Input() set copyApplicationId(value: string | number) {
    if (value) {
      this.intialCopyApplicationIdUpdated.next(parseInt(value.toString()));
    }
  }
  @Output() dataCopied = new EventEmitter();

  public applicationOptions: GetApplicationDataResponse[] = [];
  public selectedApplication: GetApplicationDataResponse;

  private intialCopyApplicationIdUpdated = new BehaviorSubject<number>(null);
  private copyApplicationOptionsLoaded = new Subject<GetApplicationDataResponse[]>();

  constructor(
    private copyAppDataService: CopyApplicationDataService,
    private localStorageService: LocalStorageService,
    private errorService: ErrorService,
    private confirmationModalService: ConfirmationModalService,
    private translation: NetzTranslateService,
    private notification: ToastNotificationService
  ) {
    super();

    this.preventLeak(
      combineLatest([this.intialCopyApplicationIdUpdated.asObservable(), this.copyApplicationOptionsLoaded.asObservable()])
    ).subscribe(([applicationId, applicationOptions]) => {
      if (!applicationId || !applicationOptions) return;
      const filteredOption = applicationOptions?.filter(app => app.applicationId === applicationId);
      if (!filteredOption?.length) return;

      this.selectedApplication = filteredOption[0];
    });
  }

  ngOnInit(): void {
    if (this.installationFlow) {
      this.preventLeak(this.copyAppDataService.getExistingApplicationIds(SkApplicationType[this.installationFlow])).subscribe(data => {
        this.applicationOptions = data;
        this.copyApplicationOptionsLoaded.next(this.applicationOptions);
      });
    }
  }

  public askCopyAppData() {
    const applicationId = this.localStorageService.getItem('application_id');
    if (applicationId) {
      this.confirmationModalService.show({
        message: () => this.translation.translateString('basic-profile.jurisdiction.copy_application_confirmation.message'),
        accept: () => {
          this.copyAppData();
        },
        reject: () => {
          // Do nothing
        },
      });
      return;
    }

    this.copyAppData();
  }

  private copyAppData() {
    const applicationId = this.localStorageService.getItem('application_id');
    const request: CopyApplicationDataRequest = {
      source_application_id: this.selectedApplication.applicationId,
      target_application_id: applicationId,
      target_type: SkApplicationType[this.installationFlow],
    };
    this.preventLeak(this.copyAppDataService.copyApplicationData(request)).subscribe(
      copyAppId => {
        this.localStorageService.setItem('application_id', copyAppId.toString());
        this.notification.success(this.translation.translateString('basic-profile.jurisdiction.transaction_completed_message'));
        this.dataCopied.emit();
      },
      error => this.errorService.throwErrorIfFailure(error, true)
    );
  }
}
